const data = [{
        id: 1,
        imagePath: 'img/img-maldives.jpg',
        decription: 'Maison sur piloti aux Maldives',
        done: false,
        link: 'https://www.tropicalement-votre.com/sejours/pilotis-maldives.php?perfid=N346700001000010000100814001234276600093P&tthid3kk=efa23295f849b80249b6294c844cb8d8&source=googadwords&utm_source=google&utm_term=ucquence&utm_medium=cpc&utm_content=194376690143_1t1&utm_campaign=FP&gclid=Cj0KCQiA5t7UBRDaARIsAOreQtignDuqIDPMzZRB-HqsMVl47FPR5mCdTUrhVWioOglzt62CIjr6VXAaAjbAEALw_wcB',
        coordinate: {
            lat: -0.681786,
            lng: 73.191414
        }
    },

    {
        id: 2,
        imagePath: 'img/img-kenya.jpg',
        decription: 'Faire un safari au Kenya',
        done: false,
        link: 'https://kenya.marcovasco.fr/?gclid=Cj0KCQiA5t7UBRDaARIsAOreQtjQNkfhS0HgySJ_VXadwFxEOZiDJsMh9gplnpqgAyInnY5oo4os2wEaAmHsEALw_wcB',
        coordinate: {
            lat: -0.52483,
            lng: 36.664008
        }
    },

    {
        id: 3,
        imagePath: 'img/img-hyeres.jpg',
        decription: 'Vivre au soleil',
        done: true,
        link: 'http://www.hyeres.fr/',
        coordinate: {
            lat: 43.165356,
            lng: 6.184500
        }
    },
    {
        id: 4,
        imagePath: 'img/conception-de-developpeur-web.jpg',
        decription: 'Devenir développeur web!',
        done: false,
        link: 'https://www.antoine-mikael.fr',
        coordinate: {
            lat: 43.126568,
            lng: 5.920554
        }
    }

]

export { data };